const initialState = () => ({
  visit: null,
  additionalVisitors: [],
  visitorsFirstVisit: false,
});

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    RESET_STATE(state) {
      Object.assign(state, initialState());
    },
    SET_VISIT(state, visit) {
      state.visit = visit;
    },
    SET_ADDITIONAL_VISITORS(state, additionalVisitors) {
      state.additionalVisitors = additionalVisitors;
    },
    SET_VISITORS_FIRST_VISIT(state, isFirstVisit) {
      state.visitorsFirstVisit = isFirstVisit;
    },
  },
  actions: {
    resetState({ commit }) {
      commit('RESET_STATE');
    },
    setVisit({ commit }, visit) {
      commit('SET_VISIT', visit);
    },
    async getAdditionalVisitors({ commit }, visitId) {
      const { default: AdditionalVisitorsService } = await import('@/services/AdditionalVisitorsService');
      const response = await AdditionalVisitorsService.getAdditionalVisitorsForVisit(visitId);
      commit('SET_ADDITIONAL_VISITORS', response.data);
    },
  },
};
